import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';

import { NavLink } from '@classes/nav-link';
import { AuthUser } from '@classes/auth/auth-user';
import { AppConfigService } from '@services/app-config.service';
import { NavService } from '@services/nav.service';
import { environment } from '@environments/environment';
import { Subscription } from 'rxjs';
import { UserService } from '@services/user.service';

@Component({
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit, OnChanges, OnDestroy {
    @Input() user: AuthUser;
    @Output() sidenavClose = new EventEmitter<void>();

    private subscription = new Subscription();

    navLinks: NavLink[];
    infoLinks: NavLink[];

    appVersion: string;
    isMaintenance: boolean;
    isLocalTranslations: boolean;

    constructor(
        private configSrv: AppConfigService,
        private navSrv: NavService,
        private userSrv: UserService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
        this.appVersion = environment.version;
        this.isMaintenance = this.configSrv.isMaintenance;
        this.isLocalTranslations = environment.localTranslations;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.setLinks();
    }

    onCloseSidenav(): void {
        this.sidenavClose.emit();
    }

    private initSubscriptions(): void {
        this.subscription.add(this.userSrv.userParametersSubject
            .subscribe(() => {
                this.infoLinks = this.navSrv.getInfoLinks();
            })
        );
    }

    private setLinks(): void {
        this.infoLinks = this.navSrv.getInfoLinks();
        this.navLinks = this.navSrv.getNavLinks();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
